module.exports = __webpack_public_path__ + "static/media/pla_clear_strew1.04e3dd18.png";